var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2816_10355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.75586 0 0 6.75586 0 15C0 23.2441 6.75586 30 15 30C23.2441 30 30 23.2441 30 15C30 6.75586 23.2441 0 15 0ZM3.57422 15C3.57422 8.70697 8.70697 3.57422 15 3.57422C17.373 3.57422 19.6583 4.31244 21.6094 5.70111L15 12.3105L5.70123 21.6094C4.31244 19.6581 3.57422 17.373 3.57422 15ZM15 26.4258C12.627 26.4258 10.3417 25.6874 8.39062 24.2988L24.2988 8.39057C25.6876 10.3417 26.4258 12.6269 26.4258 15C26.4258 21.2929 21.293 26.4258 15 26.4258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2441 23.2441 30 15 30V26.4258C21.293 26.4258 26.4258 21.2929 26.4258 15C26.4258 12.6269 25.6876 10.3417 24.2988 8.39062L15 17.6894V12.3105L21.6094 5.70111C19.6583 4.31244 17.373 3.57422 15 3.57422V0C23.2441 0 30 6.75586 30 15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2816_10355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.51da5c09c92be31ebae407b918af95b8.svg";
export { ForwardRef as ReactComponent };